import React from "react";
import { useNavigate } from "react-router-dom";
import { useIngredientSession } from "../hooks/useIngredientSession";
import { RiCloseLine } from "react-icons/ri";
import { MdOutlineScience, MdSearch } from "react-icons/md";

export default function IngredientSessionBar() {
  const {
    sessionIngredients,
    removeIngredient,
    clearSession,
    count,
    MAX_SESSION_INGREDIENTS,
  } = useIngredientSession();
  const navigate = useNavigate();

  if (count === 0) return null;

  const handleSearch = () => {
    const uris = sessionIngredients.map((ing) => ing.uri).join(",");
    navigate(`/ingredients/search?ingredients=${encodeURIComponent(uris)}`);
    clearSession();
  };

  return (
    <div className="fixed bottom-16 left-0 right-0 z-50 pointer-events-none">
      <div className="max-w-[1200px] mx-auto px-4 pb-4">
        <div className="pointer-events-auto flex items-center gap-3 p-3 bg-white border border-secondary/10 rounded-2xl shadow-xl shadow-secondary/10">
          {/* Selected ingredients */}
          <div className="flex items-center gap-2 flex-1 min-w-0 overflow-x-auto hide-scrollbar">
            {sessionIngredients.map((item) => (
              <div
                key={item.uri}
                className="flex items-center gap-1.5 pl-2.5 pr-1.5 py-1.5 bg-emerald-500/8 rounded-full flex-shrink-0 group"
              >
                <MdOutlineScience className="size-3.5 text-emerald-600 flex-shrink-0" />
                <span className="text-12 font-text font-medium text-secondary max-w-[120px] truncate">
                  {item.name}
                </span>
                <button
                  onClick={() => removeIngredient(item.uri)}
                  className="flex items-center justify-center size-5 rounded-full hover:bg-emerald-500/15 transition-colors"
                  aria-label={`Remove ${item.name} from ingredient session`}
                >
                  <RiCloseLine className="size-3.5 text-secondary/60 group-hover:text-secondary" />
                </button>
              </div>
            ))}
          </div>

          {/* Count and actions */}
          <div className="flex items-center gap-2 flex-shrink-0">
            <span
              className="text-12 font-text text-secondary/60 hidden sm:block"
              aria-live="polite"
            >
              {count} of {MAX_SESSION_INGREDIENTS}
            </span>

            <button
              onClick={clearSession}
              className="px-3 py-2 text-12 font-text font-medium text-secondary/70 hover:text-secondary rounded-lg hover:bg-secondary/5 transition-colors"
              aria-label="Clear all ingredients from session"
            >
              Clear
            </button>

            <button
              onClick={handleSearch}
              disabled={count < 1}
              className="inline-flex items-center gap-1.5 px-4 py-2 text-14 font-text font-medium text-white bg-emerald-500 rounded-lg hover:bg-emerald-600 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
            >
              <MdSearch className="size-4" />
              Search
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
